import React from 'react';
import { FilterBar } from './filter-bar';
import { CandidatesList } from './candidates-list';
import { CommitButton } from './commit-button';
import { Providers } from './providers';
import { LoadingCandidates } from './loading-candidates';
import { useAutoEnrollmentFeatureVisibility } from '../hooks/use-auto-enrollment-feature-visibility';
import { CandidateDistributor } from './candidate-distributor';

export const AutoEnrollmentPage = () => {
    const isVisible = useAutoEnrollmentFeatureVisibility();
    if (!isVisible) {
        return null;
    }
    return (
        <Providers>
            <CandidateDistributor />
            <div style={{ padding: '20px'}}>
                <h1>
                    Auto Enrollment
                </h1>
                <FilterBar />
                <LoadingCandidates />
                <CandidatesList />
                <div
                    style={{ display: 'flex', justifyContent: 'flex-end'}}
                >
                    <CommitButton />
                </div>
            </div>
        </Providers>
    );
};
